var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissionMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 560,
    viewBox: "0 0 448 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_18",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 448,
    height: 560
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58173 0 8.00001 0H205.478C207.12 0 208.721 0.504879 210.066 1.44615L263.077 38.5539C264.422 39.4951 266.023 40 267.665 40H440C444.418 40 448 43.5817 448 48V552C448 556.418 444.418 560 440 560H168C163.582 560 160 556.418 160 552V504C160 499.582 156.418 496 152 496H8C3.58172 496 0 492.418 0 488V8Z",
    fill: "#121517"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 560,
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionMask);
export default __webpack_public_path__ + "static/media/mission-mask.46a257d5932de2a36b3fcf38b105693d.svg";
export { ForwardRef as ReactComponent };